

// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { logout, getCurrentUser } from '../../utils/auth';
// import './Navbar.css';

// interface NavbarProps {
//   activeTab: string;
//   onTabChange: (tab: string) => void;
// }

// const Navbar: React.FC<NavbarProps> = ({ activeTab, onTabChange }) => {
//   const navigate = useNavigate();
//   const user = getCurrentUser();

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   const handleDashboardClick = () => {
//     navigate('/dashboard');
//   };

//   const tabs = [
//     'Calls',
//     'Conversations',
//     'Transcriptions',
//     'EmailConfig',
//     'Timings',
//     // 'Doctors',
//     'Pricing',
//     'Appointments',
//     'Feedback'
//   ];

//   return (
//     <nav className="navbar">
//       <div className="navbar-brand" onClick={handleDashboardClick} style={{ cursor: 'pointer' }}>
//         <h2>Admin Dashboard</h2>
//       </div>
//       <div className="navbar-tabs">
//         {tabs.map((tab) => (
//           <button
//             key={tab}
//             className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
//             onClick={() => onTabChange(tab)}
//           >
//             {tab === 'EmailConfig' ? 'Email Config' : tab}
//           </button>
//         ))}
//       </div>
//       <div className="navbar-user">
//         {/* <span>Welcome, {user?.name || user?.username || 'Admin'}</span> */}
//         <button onClick={handleLogout} className="logout-btn">
//           Logout
//         </button>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;






import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, getCurrentUser } from '../../utils/auth';
import './Navbar.css';

interface NavbarProps {
  activeTab: string;
  onTabChange: (tab: string) => void; // keep for backward compatibility, but we'll override navigation
}

const Navbar: React.FC<NavbarProps> = ({ activeTab, onTabChange }) => {
  const navigate = useNavigate();
  const user = getCurrentUser();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleDashboardClick = () => {
    navigate('/dashboard');
  };

  const handleTabClick = (tab: string) => {
    // First, notify parent (if needed) – optional
    onTabChange(tab);
    
    // Then navigate directly based on tab name
    let route = '';
    switch (tab) {
      case 'Calls':
        route = '/calls';
        break;
      case 'Conversations':
        route = '/conversations';
        break;
      case 'Transcriptions':
        route = '/transcriptions';
        break;
      case 'EmailConfig':
        route = '/emailconfig';
        break;
      case 'Timings':
        route = '/timings';
        break;
      case 'Pricing':
        route = '/pricing';
        break;
      case 'Appointments':
        route = '/appointments';
        break;
      case 'Feedback':
        route = '/feedback';
        break;
      default:
        route = '/dashboard';
    }
    navigate(route);
  };

  const tabs = [
    'Calls',
    'Conversations',
    'Transcriptions',
    'EmailConfig',
    'Timings',
    'Pricing',
    'Appointments',
    'Feedback'
  ];

  return (
    <nav className="navbar">
      <div className="navbar-brand" onClick={handleDashboardClick} style={{ cursor: 'pointer' }}>
        <h2>Admin Dashboard</h2>
      </div>
      <div className="navbar-tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
            onClick={() => handleTabClick(tab)}
          >
            {tab === 'EmailConfig' ? 'Email Config' : tab}
          </button>
        ))}
      </div>
      <div className="navbar-user">
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;